import { Cache } from "memory-cache";
import { Client } from "../service/esiclient";
import { IndustryIndexEntity } from "./IndustryIndexEntity";

const esiClient = new Client();

// Cache
const cache = new Cache();

export async function getCachedIndexEntity(solarsystem_id: number): Promise<IndustryIndexEntity | null> {
  let entity: any = await cache.get("indexdata-" + solarsystem_id.toString());
  if (entity) {
    return entity;
  }
  try {
    const list = await getCachedIndustryIndex();
    if (list !== null) {
      const data = list.find((x) => x.solar_system_id === solarsystem_id);
      if (data !== null) {
        entity = new IndustryIndexEntity(solarsystem_id, data);
        cache.put("indexdata-" + solarsystem_id.toString(), entity, 60 * 60 * 1000 /* 1 hour */);
        return entity;
      } else {
        return null;
      }
    } else {
      return null;
    }
  } catch (error) {
    console.error(error);
    return null;
  }
}
export async function getCachedIndexEntityAll(): Promise<IndustryIndexEntity[] | null> {
  let entity: any = await cache.get("indexdataAll");
  if (entity) {
    return entity;
  }
  try {
    const list = await getCachedIndustryIndex();
    let entityList: IndustryIndexEntity[] = [];
    if (list !== null) {
      for (var i = 0; i < list.length; i++) {
        if (list[i] !== null) {
          entity = new IndustryIndexEntity(list[i].solar_system_id, list[i]);
          entityList.push(entity);
        }
      }
      if (entityList.length) {
        cache.put("indexdataAll", entityList, 60 * 60 * 1000 /* 1 hour */);
        return entityList;
      } else {
        return null;
      }
    } else {
      return null;
    }
  } catch (error) {
    console.error(error);
    return null;
  }
}

export async function getCachedIndustryIndex(): Promise<any[] | null> {
  let list: any = await cache.get("industryindex");
  if (list) {
    return list;
  }
  try {
    const listdata = await esiClient.get_industry_systems(null, null);
    if (listdata !== null) {
      cache.put("industryindex", listdata, 60 * 60 * 1000);
      return listdata;
    } else {
      return [];
    }
  } catch {
    return null;
  }
}
